/* eslint-disable react-hooks/exhaustive-deps */
import { useLoadScript } from "@react-google-maps/api";
import clsx from "clsx";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Card, FormGroup, Label, Spinner } from "reactstrap";
import { v4 as uuid } from "uuid";
import Content from "../../layout/content/Content";
import { deleteFile, deleteMultipleFiles, uploadFile } from "../../redux/Apislices/awsSlice";
import { getcity, getcityByProvince } from "../../redux/Apislices/citySlice";
import {
  addCommunity,
  editCommunity,
  getSingleCommunity,
  handleAddCommunity,
  handleComAws,
  handleCommunityAddReset,
} from "../../redux/Apislices/communitySlice";
import { getCountry } from "../../redux/Apislices/countrySlice";
import { getHomeType } from "../../redux/Apislices/homeTypeSlice";
import { getneighbourhoodByCity } from "../../redux/Apislices/neighbourhoodSlice";
import { getprovinceByCountry } from "../../redux/Apislices/provinceSlice";
import { getLocationData } from "../../utils/location";
import { Block, BlockContent, BlockHead, BlockTitle, Button, Col, Icon, Row } from "../Component";
import Main from "../Draggable/Main";
import ComHeader from "./ComHeader";
import ComNav from "./ComNav";
import styles from "./community.module.scss";

const Community2 = ({ toggleNext, toggleBack, activeIconTab, toggleIconTab }) => {
  const dispatch = useDispatch();
  const { community, profile, city, homeTypeData } = useSelector((state) => ({
    community: state?.community,
    city: state?.city,
    profile: state?.profile,
    homeTypeData: state?.homeType,
  }));
  const navigate = useNavigate();
  const { type, id } = useParams();

  const [comData, setComData] = useState(false);

  const [mediaArray, setMediaArray] = useState([]);
  const [videoUrl, setVideoUrl] = useState("");
  const [vTour, setVTour] = useState("");

  const [coverImg, setCoverImg] = useState("");
  const [deleteArray, setDeleteArray] = useState([]);

  const [trigger, setTrigger] = useState(false);

  useEffect(() => {
    if (trigger) {
      // setTimeout(() => {
      setTrigger(false);
      // }, 500);
    }
  }, [trigger]);

  const handleDelete = async (path) => {
    let toastId = toast.loading("Deleting...");
    setTimeout(() => {
      toast.dismiss(toastId);
    }, 5000);
    dispatch(
      deleteFile(
        { path },
        (res) => {
          if (type === "edit" || type === "duplicate") {
            let data = {
              ...comData,
              images: comData?.images?.filter((li) => li !== path),
            };
            dispatch(
              editCommunity(
                id,
                data,
                (res) => {
                  dispatch(getSingleCommunity({ id }));
                  toast.dismiss(toastId);
                  setTrigger(true);
                  toast.success("Image Deleted");
                },
                (res) => {
                  toast.success(res.message);
                }
              )
            );
          } else {
            let filtered = mediaArray?.filter((li) => li !== path);
            dispatch(handleComAws(filtered));
            toast.dismiss(toastId);
            toast.success("Image Deleted");
          }
        },
        () => {}
      )
    );
  };

  const handleMultiple = (e) => {
    if (e.target.checked) {
      setDeleteArray([...deleteArray, e.target.value]);
    } else {
      let a = deleteArray?.filter((li) => li !== e.target.value);
      setDeleteArray(a);
    }
  };

  const deleteMultiples = async () => {
    let toastId = toast.loading("Deleting...");
    setTimeout(() => {
      toast.dismiss(toastId);
    }, 5000);
    dispatch(
      deleteMultipleFiles(
        { paths: deleteArray },
        (res) => {
          if (type === "edit") {
            let data = {
              ...comData,
              images: comData?.images?.filter((li) => !deleteArray?.includes(li)),
            };
            dispatch(
              editCommunity(
                id,
                data,
                (res) => {
                  dispatch(getSingleCommunity({ id }));
                  toast.dismiss(toastId);
                  setDeleteArray([]);
                  toast.success("Image(s) Deleted");
                },
                (res) => {
                  toast.success(res.message);
                }
              )
            );
          } else {
            let ab = mediaArray?.filter((li) => !deleteArray?.includes(li));
            dispatch(handleComAws(ab));
            toast.dismiss(toastId);
            toast.success("Images Deleted");
            setDeleteArray([]);
          }
        },
        () => {
          toast.dismiss(toastId);
        }
      )
    );
  };

  const uploadImage = async (file) => {
    let toastId = toast.loading("Uploading...");
    setTimeout(() => {
      toast.dismiss(toastId);
      setTrigger(true);
    }, 5000);
    dispatch(
      uploadFile(
        file,
        (res) => {
          if (type === "edit") {
            let img = [];
            if (res?.data) {
              img = res?.data?.map((li) => li?.url);
            }
            let images = [...comData?.images];
            let data = {
              ...comData,
              images: [...images, ...img],
            };
            console.log("data: ", data);
            dispatch(
              editCommunity(
                id,
                data,
                (res) => {
                  dispatch(getSingleCommunity({ id }));
                  setTrigger(true);
                  toast.dismiss(toastId);
                  toast.success("Image(s) Uploaded");
                },
                (res) => {
                  toast.success(res.message);
                }
              )
            );
          } else if (community?.addCommunity?.["com-aws"]) {
            let image = community?.addCommunity?.["com-aws"];
            image = [...image, ...res?.data?.map((li) => li?.url)];
            dispatch(handleComAws(image));
            toast.dismiss(toastId);
            setMediaArray(image);
            setTrigger(true);
            setTrigger(true);
            toast.success("Image(s) Uploaded");
          } else if (!community?.addCommunity?.["com-aws"]) {
            if (!mediaArray?.length) {
              dispatch(handleComAws([...res?.data?.map((li) => li?.url)]));
              setMediaArray([...res?.data?.map((li) => li?.url)]);
            } else {
              dispatch(handleComAws([...mediaArray, res?.data?.map((li) => li?.url)]));
              setMediaArray([...mediaArray, res?.data?.map((li) => li?.url)]);
            }
            setTrigger(true);
            toast.dismiss(toastId);
            toast.success("Image(s) Uploaded");
          }
        },
        (res) => {
          toast.error(res?.message);
          toast.dismiss(toastId);
        }
      )
    );
  };

  const handleCoverImg = (item, index) => {
    setCoverImg(item);

    const updatedArray = [...mediaArray];

    const elementToMove = updatedArray[index];

    updatedArray.splice(index, 1);

    updatedArray.splice(0, 0, elementToMove);
    setMediaArray(updatedArray);
    if (type === "edit" || type === "duplicate") {
      let data = {
        ...comData,
        images: updatedArray,
        type: "presale",
      };
      if (videoUrl) {
        data = { ...data, video: videoUrl };
      }
      if (vTour) {
        data = { ...data, vtour: vTour };
      }
      dispatch(
        editCommunity(
          id,
          data,
          (res) => {
            dispatch(getSingleCommunity({ id }));
            toast.success("Cover Image Set");
          },
          (res) => {
            toast.success(res.message);
          }
        )
      );
    } else {
      dispatch(handleComAws(updatedArray));
      toast.success("Cover Image Set");
    }
  };

  const onDrop = useCallback(
    (acceptedFiles, fileRejections) => {
      fileRejections.forEach((file) => {
        file.errors.forEach((err) => {
          if (err.code === "file-too-large") {
            toast.error("File is larger than 20 MB");
          }
          if (err.code === "file-invalid-type") {
            toast.error(err.message);
          }
        });
      });
      console.log("acceptedFiles: ", acceptedFiles);

      const newImages = acceptedFiles.map((file, index) => {
        let devName = comData?.name?.split(" ")?.join("-");

        let cityName = city?.city
          ?.find((li) => li?._id === comData?.address?.city)
          ?.name?.split(" ")
          ?.join("-");

        let homeTypeName = comData?.homeTypes?.[0]
          ? `-${homeTypeData?.homeType
              ?.find((li) => li?._id === comData?.homeTypes?.[0])
              ?.name?.split(" ")
              ?.join("-")}`
          : "";

        const newName = `${devName}-${cityName}${homeTypeName}-${uuid()?.slice(0, 8)}-${
          !mediaArray?.length ? index + 1 : mediaArray?.length + index + 1
        }.${file.name.split(".").pop()}`;
        console.log("newName: ", newName);
        return new File([file], newName, { type: file.type });
      });

      const formData = new FormData();
      newImages.forEach((file) => {
        formData.append("file", file);
      });
      formData.append("folder", "master community");
      formData.append("width", 1440);
      formData.append("height", 900);
      uploadImage(formData);
    },
    [
      city?.city,
      comData?.address?.city,
      comData?.homeTypes,
      comData?.name,
      homeTypeData?.homeType,
      mediaArray?.length,
      uploadImage,
    ]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      "image/jpg": [".jpg"],
      "image/jpeg": [".jpeg"],
      "image/png": [".png"],
    },
    maxSize: 20971520,
  });

  const handleBack = () => {
    toggleBack();
  };

  const handlePayload = () => {
    let data = {
      ...comData,
      images: mediaArray,
      video: videoUrl,
      vtour: vTour,
    };

    return data;
  };

  const handleAddUpdate = async (CB) => {
    let data = handlePayload();

    if (type === "edit") {
      dispatch(
        editCommunity(
          id,
          data,
          (res) => {
            dispatch(getSingleCommunity({ id }));
            CB({ success: true });
          },
          (res) => {
            toast.success(res.message);
          }
        )
      );
    } else {
      dispatch(
        handleAddCommunity({
          ...community?.addCommunity?.data,
          ...data,
        })
      );
      dispatch(handleComAws([]));
      CB({ success: true });
    }
  };

  const handleNext = () => {
    handleAddUpdate((res) => {
      if (res?.success) {
        toggleNext();
      }
    });
  };

  const addToDraft = () => {
    let data = handlePayload();

    if (type === "edit") {
      dispatch(
        editCommunity(
          id,
          data,
          (res) => {
            dispatch(handleCommunityAddReset());
            navigate("/master-community");
            toast.success("Master Community Updated");
          },
          (res) => {
            toast.success(res.message);
          }
        )
      );
    } else {
      dispatch(
        addCommunity(
          data,
          (res) => {
            dispatch(handleCommunityAddReset());
            navigate("/master-community");
            toast.success("Master Community saved as draft");
          },
          (res) => {
            toast.success(res.message);
          }
        )
      );
    }
  };

  useEffect(() => {
    dispatch(getcity());
  }, [dispatch]);

  useEffect(() => {
    if (mediaArray?.length) {
      setCoverImg(mediaArray?.[0]);
    }
  }, [mediaArray, coverImg]);

  useEffect(() => {
    if (community?.addCommunity?.data) {
      let mediaInfo = community?.addCommunity?.data;
      if (mediaInfo) {
        setComData(mediaInfo);
      }
    } else if (community?.communityBySlug) {
      let data = community?.communityBySlug;
      setComData(data);
    }
  }, [community?.addCommunity?.data, community?.communityBySlug]);

  useEffect(() => {
    if (comData) {
      setVideoUrl(comData?.video || videoUrl);
      setVTour(comData?.vtour || vTour);
      dispatch(handleComAws(comData?.images || []));
    }
  }, [comData]);

  useEffect(() => {
    if (community?.addCommunity?.["com-aws"]) {
      setMediaArray(community?.addCommunity?.["com-aws"]);
    }
  }, [community?.addCommunity?.["com-aws"]]);

  return (
    <>
      <Content>
        <ComHeader
          title={comData?.name ? comData.name : type === "edit" ? "Edit Master Community" : "Add Master Community"}
          btnText={type === "edit" ? "Update" : "Add as Draft"}
          addToDraft={() => {
            addToDraft();
          }}
        />

        <Block>
          <Card className="card-bordered">
            <div className="card-aside-wrap" id="user-detail-block">
              <div className="card-content">
                <ComNav toggleIconTab={toggleIconTab} activeIconTab={activeIconTab} update={handleAddUpdate} />

                <div className="card-inner">
                  <Block>
                    <BlockHead>
                      <BlockTitle tag="h4">Media</BlockTitle>
                    </BlockHead>

                    <BlockContent>
                      <Row>
                        <Col sm={"12"} md={"12"} lg={"12"}>
                          <div className={clsx(styles.bannerWhite)}>
                            <h1 className="text-sm-start text-center">
                              Drag and drop the images to customize the image gallery order
                            </h1>
                            <div
                              // className={clsx(styles.bannerDiv)}
                              {...getRootProps({ className: styles.bannerDiv })}
                            >
                              {/* <img src="/images/associate/8109268/8109268.png" alt="8109268" className="img-fluid" /> */}

                              <Icon
                                name="upload"
                                style={{
                                  fontSize: "48px",
                                  marginBottom: "10px",
                                }}
                              ></Icon>

                              <input
                                type="file"
                                id="profile1"
                                name="profile1"
                                style={{ display: "none" }}
                                {...getInputProps()}
                                readOnly
                              />
                              <p className={clsx(styles.para1)}>Drag and drop the images the gallery images here</p>
                              <p className={clsx(styles.para2)}>(Maximum size 1440x900)</p>
                              <button type="file" id="myfile" name="myfile">
                                Select and Upload
                              </button>
                            </div>

                            <p className={("text-sm-start text-center mt-4 mb-5", styles.para2)}>
                              Click on the star icon to select the cover image
                            </p>
                            {!trigger ? (
                              <Main
                                cards={mediaArray}
                                setCards={setMediaArray}
                                deleteArray={deleteArray}
                                coverImg={coverImg}
                                setDeleteArray={setDeleteArray}
                                handleCoverImg={handleCoverImg}
                                handleDelete={handleDelete}
                                handleMultiple={handleMultiple}
                              />
                            ) : null}

                            {deleteArray?.length ? (
                              <div className={clsx(styles.deleteBtn)}>
                                <button onClick={deleteMultiples}>Delete Selected</button>
                              </div>
                            ) : null}
                          </div>
                        </Col>
                      </Row>
                    </BlockContent>
                  </Block>

                  {/* <br />
                  <br /> */}

                  <Block>
                    <BlockHead>
                      <BlockTitle tag="h4">Video Tour</BlockTitle>
                    </BlockHead>

                    <BlockContent>
                      <Row className="gy-4">
                        {/* Video URL */}
                        <Col sm={"12"} md={"12"} lg={"12"}>
                          <FormGroup>
                            <Label htmlFor="name" className="form-label">
                              Video URL
                            </Label>
                            <div className="form-control-wrap">
                              <input
                                className={`form-control `}
                                type="text"
                                id="videoUrl"
                                placeholder={"Enter Video URL such as YouTube, Vimeo, etc."}
                                value={videoUrl}
                                autoComplete="off"
                                name="videoUrl"
                                onChange={(e) => {
                                  setVideoUrl(e.target.value);
                                }}
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </BlockContent>
                  </Block>

                  <br />
                  <br />

                  <Block>
                    <BlockHead>
                      <BlockTitle tag="h4">360 Virtual Tour (3D Walkthrough)</BlockTitle>
                    </BlockHead>

                    <BlockContent>
                      <Row className="gy-4">
                        {/* 360 Virtual Tour */}
                        <Col sm={"12"} md={"12"} lg={"12"}>
                          <FormGroup>
                            <Label htmlFor="name" className="form-label">
                              360 Virtual Tour
                            </Label>
                            <div className="form-control-wrap">
                              <textarea
                                className={`form-control `}
                                type="text"
                                id="vTour"
                                placeholder="Enter virtual tour embedded code. Example: https//"
                                value={vTour}
                                rows={4}
                                autoComplete="off"
                                name="vTour"
                                onChange={(e) => {
                                  setVTour(e.target.value);
                                }}
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </BlockContent>
                  </Block>
                </div>
              </div>
            </div>
          </Card>

          <div
            style={{
              margin: "15px 0",
              display: "flex",
              gap: "1rem",
            }}
          >
            <Button
              color="secondary"
              outline
              onClick={handleBack}
              style={{
                fontSize: "16px",
                padding: "6px 25px",
              }}
            >
              <span>Back</span>
            </Button>

            <Button
              color={"info"}
              onClick={handleNext}
              style={{
                fontSize: "16px",
                padding: "6px 25px",
              }}
            >
              <span>Next</span>
            </Button>
          </div>
        </Block>
      </Content>
    </>
  );
};

export default Community2;
